<template>
  <div>
    <div class="wraper" v-if="!isProjectLoading">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader :title="title" :excel-org-id="oID"></ProjectHeader>
      </div>
      <div class="container-fluid mycontainer-fluid content">
        <div class="gp-f-tabs">
          <router-link
            tag="button"
            type="button"
            class="gp-f-tabs__item"
            :class="{ 'gp-f-tabs__item--active': mode === 'balance' }"
            :to="{
              name: 'IndicatorsBalance',
              params: { id: $route.params.id }
            }"
          >
            Бухгалтерский баланс
          </router-link>
          <router-link
            tag="button"
            type="button"
            class="gp-f-tabs__item"
            :class="{ 'gp-f-tabs__item--active': mode === 'income' }"
            :to="{
              name: 'IndicatorsIncome',
              params: { id: $route.params.id }
            }"
          >
            Отчет о финансовых результатах
          </router-link>
          <router-link
            tag="button"
            type="button"
            class="gp-f-tabs__item"
            :to="{
              name: 'IndicatorsCashflows',
              params: { id: $route.params.id }
            }"
          >
            Отчет о движении денежных средств
          </router-link>
        </div>
        <div class="gp-f-toolbar">
          <label class="gp-f-select" v-if="orgs.length">
            <select
              class="gp-f-select__field"
              v-model="activeOrgId"
              @change="onOrgChange"
            >
              <option v-for="org in orgs" :key="org.ID" :value="org.ID">
                {{ org.UF_NAME
                }}{{
                  org.UF_IS_OWNER_PROJECT ? ": Заявитель" : ": Поручитель"
                }}
              </option>
            </select>
          </label>
          <div v-if="recordsLoaded" class="gp-f-years">
            <label
              v-for="item in indicators.yearAr"
              :key="item.UF_YEAR"
              class="gp-f-toggle"
            >
              <input
                type="checkbox"
                class="gp-f-toggle__input"
                @click="showTable = false"
                @change="showTable = true"
                v-model="item.IS_ACTIVE"
              />
              <span class="gp-f-toggle__slider"></span>
              <span class="gp-f-toggle__label">{{ item.UF_YEAR }}</span>
            </label>
          </div>
          <div v-if="recordsLoaded" class="gp-f-toolbar__checkbox">
            <label
              ><input
                type="checkbox"
                v-model="curOrg.UF_IS_NOT_FINANCE_OTCH"
                @change="setIsNotFinance"
              />
              <strong>Отсутствует отчетность</strong></label
            ><br />
            Поставьте галочку, если у компании отсутствует финансовая отчетность
          </div>
        </div>
        <div v-if="recordsLoaded">
          <table
            v-if="showTable"
            class="c-indicator gp-f-table"
            style="width: 100%"
          >
            <template v-if="mode === 'balance'">
            <thead>
              <tr>
                <th class="tab-wid-630" rowspan="2">Баланс, тыс. руб.</th>
                <th class="tab-wid-250" colspan="2" style="text-align: center">
                  <br />Код<br /><br />
                </th>
                <th
                  style="text-align: center"
                  colspan="4"
                  v-for="item in indicators.yearAr"
                  v-if="item.IS_ACTIVE"
                >
                  {{ item.UF_YEAR }}, по состоянию на
                </th>
              </tr>
              <tr>
                <th>
                  <br /><span style="font-weight: normal;">По приказу №66н</span
                  ><br /><br />
                </th>
                <th>
                  <br /><span style="font-weight: normal;">По приказу №67н</span
                  ><br /><br />
                </th>
                <th
                  style="text-align: center"
                  v-for="item in indicatorYears"
                  v-html="item"
                ></th>
              </tr>
            </thead>
            <fragment v-for="tb in finSp.BALANS">
              <tbody>
                <tr>
                  <td class="gr" v-if="tb.UF_CODE === 'r_passiv_itogo'">
                    <strong>{{ tb.UF_NAME }}</strong>
                  </td>
                  <td v-else-if="tb.UF_CODE === ''">
                    {{ tb.UF_NAME }}
                  </td>
                  <td v-else>
                    <strong>{{ tb.UF_NAME }}</strong>
                  </td>
                  <fragment v-if="tb.UF_CODE === 'r_passiv_itogo'">
                    <td class="gr"></td>
                    <td class="gr"></td>
                    <fragment
                      v-for="year in indicators.yearAr"
                      v-if="year.IS_ACTIVE"
                    >
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorAPSum(
                            indicators.indicators.BALANS,
                            finSp.BALANS,
                            year.UF_YEAR,
                            "UF_KV1"
                          ) | toCurrencyOO
                        }}
                      </td>
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorAPSum(
                            indicators.indicators.BALANS,
                            finSp.BALANS,
                            year.UF_YEAR,
                            "UF_KV2"
                          ) | toCurrencyOO
                        }}
                      </td>
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorAPSum(
                            indicators.indicators.BALANS,
                            finSp.BALANS,
                            year.UF_YEAR,
                            "UF_KV3"
                          ) | toCurrencyOO
                        }}
                      </td>
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorAPSum(
                            indicators.indicators.BALANS,
                            finSp.BALANS,
                            year.UF_YEAR,
                            "UF_KV4"
                          ) | toCurrencyOO
                        }}
                      </td>
                    </fragment>
                  </fragment>
                  <fragment v-if="tb.UF_CODE === 'clean_assets'">
                    <td></td>
                    <td></td>
                    <fragment
                      v-for="year in indicators.yearAr"
                      v-if="year.IS_ACTIVE"
                    >
                      <td :class="{ gr: year.KV1_IS_VISUALIZATION }">
                        <vue-numeric
                          :minus="true"
                          :precision="2"
                          separator="space"
                          output-type="Number"
                          v-on:keypress="
                            isNumber(
                              $event,
                              tb.UF_IS_MINUS,
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                                .UF_KV1
                            )
                          "
                          @change="
                            numberFix(
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR],
                              'UF_KV1'
                            )
                          "
                          :disabled="editDisabled || year.KV1_IS_EDIT === 0"
                          v-if="
                            indicators.indicators.BALANS[tb.ID] &&
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                          "
                          type="text"
                          class="i-main-style"
                          v-model="
                            indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                              .UF_KV1
                          "
                        />
                      </td>
                      <td :class="{ gr: year.KV2_IS_VISUALIZATION }">
                        <vue-numeric
                          :minus="true"
                          :precision="2"
                          separator="space"
                          output-type="Number"
                          v-on:keypress="
                            isNumber(
                              $event,
                              tb.UF_IS_MINUS,
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                                .UF_KV2
                            )
                          "
                          @change="
                            numberFix(
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR],
                              'UF_KV2'
                            )
                          "
                          :disabled="editDisabled || year.KV2_IS_EDIT === 0"
                          v-if="
                            indicators.indicators.BALANS[tb.ID] &&
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                          "
                          type="text"
                          class="i-main-style"
                          v-model="
                            indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                              .UF_KV2
                          "
                        />
                      </td>
                      <td :class="{ gr: year.KV3_IS_VISUALIZATION }">
                        <vue-numeric
                          :minus="true"
                          :precision="2"
                          separator="space"
                          output-type="Number"
                          v-on:keypress="
                            isNumber(
                              $event,
                              tb.UF_IS_MINUS,
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                                .UF_KV3
                            )
                          "
                          @change="
                            numberFix(
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR],
                              'UF_KV3'
                            )
                          "
                          :disabled="editDisabled || year.KV3_IS_EDIT === 0"
                          v-if="
                            indicators.indicators.BALANS[tb.ID] &&
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                          "
                          type="text"
                          class="i-main-style"
                          v-model="
                            indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                              .UF_KV3
                          "
                        />
                      </td>
                      <td :class="{ gr: year.KV4_IS_VISUALIZATION }">
                        <vue-numeric
                          :minus="true"
                          :precision="2"
                          separator="space"
                          output-type="Number"
                          v-on:keypress="
                            isNumber(
                              $event,
                              tb.UF_IS_MINUS,
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                                .UF_KV4
                            )
                          "
                          @change="
                            numberFix(
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR],
                              'UF_KV4'
                            )
                          "
                          :disabled="editDisabled || year.KV4_IS_EDIT === 0"
                          v-if="
                            indicators.indicators.BALANS[tb.ID] &&
                              indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                          "
                          type="text"
                          class="i-main-style"
                          v-model="
                            indicators.indicators.BALANS[tb.ID][year.UF_YEAR]
                              .UF_KV4
                          "
                        />
                      </td>
                    </fragment>
                  </fragment>
                </tr>
                <fragment
                  v-if="tb.UF_CODE !== 'r_passiv_itogo'"
                  v-for="fl1 in tb.CHILDS"
                >
                  <tr>
                    <td
                      v-if="!fl1.UF_IS_ITOGO"
                      :colspan="3 + indicatorYears.length * 4"
                    >
                      <strong>{{ fl1.UF_NAME }}</strong>
                    </td>
                    <td class="gr" v-if="fl1.UF_IS_ITOGO" :colspan="3">
                      <strong>{{ fl1.UF_NAME }}</strong>
                    </td>
                    <fragment
                      v-for="year in indicators.yearAr"
                      v-if="fl1.UF_IS_ITOGO && year.IS_ACTIVE"
                    >
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorChildSum(
                            indicators.indicators.BALANS,
                            tb.CHILDS,
                            year.UF_YEAR,
                            "UF_KV1"
                          ) | toCurrencyOO
                        }}
                      </td>
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorChildSum(
                            indicators.indicators.BALANS,
                            tb.CHILDS,
                            year.UF_YEAR,
                            "UF_KV2"
                          ) | toCurrencyOO
                        }}
                      </td>
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorChildSum(
                            indicators.indicators.BALANS,
                            tb.CHILDS,
                            year.UF_YEAR,
                            "UF_KV3"
                          ) | toCurrencyOO
                        }}
                      </td>
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorChildSum(
                            indicators.indicators.BALANS,
                            tb.CHILDS,
                            year.UF_YEAR,
                            "UF_KV4"
                          ) | toCurrencyOO
                        }}
                      </td>
                    </fragment>
                  </tr>
                  <tr v-for="fl2 in fl1.CHILDS">
                    <td v-if="!fl2.UF_IS_ITOGO">
                      {{ fl2.UF_NAME }}
                      <a
                        v-if="fl2.UF_IS_MINUS === 1"
                        class="icon-help-blue"
                        v-tooltip="{
                          content: 'Доступен ввод со знаком',
                          classes: 'message'
                        }"
                      ></a>
                    </td>
                    <td v-else class="gr">
                      <strong>{{ fl2.UF_NAME }}</strong>
                    </td>
                    <td :class="{ gr: fl2.UF_IS_ITOGO }">
                      {{ fl2.UF_PRIKAZ_66N }}
                    </td>
                    <td :class="{ gr: fl2.UF_IS_ITOGO }">
                      {{ fl2.UF_PRIKAZ_67N }}
                    </td>
                    <fragment
                      v-for="year in indicators.yearAr"
                      v-if="fl2.UF_IS_ITOGO && year.IS_ACTIVE"
                    >
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorSum(
                            indicators.indicators.BALANS,
                            fl1.CHILDS,
                            year.UF_YEAR,
                            "UF_KV1"
                          ) | toCurrencyOO
                        }}
                      </td>
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorSum(
                            indicators.indicators.BALANS,
                            fl1.CHILDS,
                            year.UF_YEAR,
                            "UF_KV2"
                          ) | toCurrencyOO
                        }}
                      </td>
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorSum(
                            indicators.indicators.BALANS,
                            fl1.CHILDS,
                            year.UF_YEAR,
                            "UF_KV3"
                          ) | toCurrencyOO
                        }}
                      </td>
                      <td class="gr" style="text-align: center">
                        {{
                          indicatorSum(
                            indicators.indicators.BALANS,
                            fl1.CHILDS,
                            year.UF_YEAR,
                            "UF_KV4"
                          ) | toCurrencyOO
                        }}
                      </td>
                    </fragment>
                    <fragment
                      v-for="year in indicators.yearAr"
                      v-if="!fl2.UF_IS_ITOGO && year.IS_ACTIVE"
                    >
                      <td :class="{ gr: year.KV1_IS_VISUALIZATION }">
                        <vue-numeric
                          :minus="true"
                          :precision="2"
                          separator="space"
                          output-type="Number"
                          v-on:keypress="
                            isNumber(
                              $event,
                              fl2.UF_IS_MINUS,
                              indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                                .UF_KV1
                            )
                          "
                          @change="
                            numberFix(
                              indicators.indicators.BALANS[fl2.ID][
                                year.UF_YEAR
                              ],
                              'UF_KV1'
                            )
                          "
                          :disabled="editDisabled || year.KV1_IS_EDIT === 0"
                          v-if="
                            indicators.indicators.BALANS[fl2.ID] &&
                              indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                          "
                          type="text"
                          class="i-main-style"
                          v-model="
                            indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                              .UF_KV1
                          "
                        />
                      </td>
                      <td :class="{ gr: year.KV2_IS_VISUALIZATION }">
                        <vue-numeric
                          :minus="true"
                          :precision="2"
                          separator="space"
                          output-type="Number"
                          v-on:keypress="
                            isNumber(
                              $event,
                              fl2.UF_IS_MINUS,
                              indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                                .UF_KV2
                            )
                          "
                          @change="
                            numberFix(
                              indicators.indicators.BALANS[fl2.ID][
                                year.UF_YEAR
                              ],
                              'UF_KV2'
                            )
                          "
                          :disabled="editDisabled || year.KV2_IS_EDIT === 0"
                          v-if="
                            indicators.indicators.BALANS[fl2.ID] &&
                              indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                          "
                          type="text"
                          class="i-main-style"
                          v-model="
                            indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                              .UF_KV2
                          "
                        />
                      </td>
                      <td :class="{ gr: year.KV3_IS_VISUALIZATION }">
                        <vue-numeric
                          :minus="true"
                          :precision="2"
                          separator="space"
                          output-type="Number"
                          v-on:keypress="
                            isNumber(
                              $event,
                              fl2.UF_IS_MINUS,
                              indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                                .UF_KV3
                            )
                          "
                          @change="
                            numberFix(
                              indicators.indicators.BALANS[fl2.ID][
                                year.UF_YEAR
                              ],
                              'UF_KV3'
                            )
                          "
                          :disabled="editDisabled || year.KV3_IS_EDIT === 0"
                          v-if="
                            indicators.indicators.BALANS[fl2.ID] &&
                              indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                          "
                          type="text"
                          class="i-main-style"
                          v-model="
                            indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                              .UF_KV3
                          "
                        />
                      </td>
                      <td :class="{ gr: year.KV4_IS_VISUALIZATION }">
                        <vue-numeric
                          :minus="true"
                          :precision="2"
                          separator="space"
                          output-type="Number"
                          v-on:keypress="
                            isNumber(
                              $event,
                              fl2.UF_IS_MINUS,
                              indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                                .UF_KV4
                            )
                          "
                          @change="
                            numberFix(
                              indicators.indicators.BALANS[fl2.ID][
                                year.UF_YEAR
                              ],
                              'UF_KV4'
                            )
                          "
                          :disabled="editDisabled || year.KV4_IS_EDIT === 0"
                          v-if="
                            indicators.indicators.BALANS[fl2.ID] &&
                              indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                          "
                          type="text"
                          class="i-main-style"
                          v-model="
                            indicators.indicators.BALANS[fl2.ID][year.UF_YEAR]
                              .UF_KV4
                          "
                        />
                      </td>
                    </fragment>
                  </tr>
                </fragment>
              </tbody>
            </fragment>
            </template>
            <template v-if="mode === 'income'">
            <thead>
              <tr style="border-bottom: none !important;">
                <td style="background: none !important;"></td>
              </tr>
              <tr style="border-bottom: none !important;">
                <td style="background: none !important;"></td>
              </tr>
              <tr>
                <th class="tab-wid-630" rowspan="2">
                  Отчет о финансовых результатах, тыс. руб.
                </th>
                <th class="tab-wid-250" colspan="2" style="text-align: center">
                  <br />Код<br /><br />
                </th>
                <th
                  style="text-align: center"
                  colspan="4"
                  v-for="item in indicators.yearAr"
                  v-if="item.IS_ACTIVE"
                >
                  {{ item.UF_YEAR }}, по накопленным итогам за
                </th>
              </tr>
              <tr>
                <th>
                  <br /><span style="font-weight: normal;">По приказу №66н</span
                  ><br /><br />
                </th>
                <th>
                  <br /><span style="font-weight: normal;">По приказу №67н</span
                  ><br /><br />
                </th>
                <th
                  style="text-align: center"
                  v-for="item in indicatorYearsFinance"
                  v-html="item"
                ></th>
              </tr>
            </thead>
            <fragment v-for="tb in finSp.FINANCE">
              <tbody>
                <tr>
                  <td :class="{ gr: tb.UF_IS_BLOCK }">
                    {{ tb.UF_NAME }}
                    <a
                      v-if="tb.UF_IS_MINUS === 1"
                      class="icon-help-blue"
                      v-tooltip="{
                        content: 'Доступен ввод со знаком',
                        classes: 'message'
                      }"
                    ></a>
                  </td>
                  <td :class="{ gr: tb.UF_IS_BLOCK }">
                    {{ tb.UF_PRIKAZ_66N }}
                  </td>
                  <td :class="{ gr: tb.UF_IS_BLOCK }">
                    {{ tb.UF_PRIKAZ_67N }}
                  </td>
                  <fragment
                    v-for="year in indicators.yearAr"
                    v-if="year.IS_ACTIVE"
                  >
                    <td
                      :class="{
                        gr: year.KV1_IS_VISUALIZATION || tb.UF_IS_BLOCK
                      }"
                    >
                      <span v-if="tb.UF_FORMULA">{{
                        finByFormula(
                          tb.ID,
                          tb.UF_FORMULA,
                          year.UF_YEAR,
                          "UF_KV1"
                        ) | toCurrencyOO
                      }}</span>
                      <div v-if="tb.ID === 20 || 15">
                        <vue-numeric
                          :minus="true"
                          :precision="2"
                          separator="space"
                          output-type="Number"
                          v-if="!tb.UF_IS_BLOCK"
                          v-on:keypress="
                            isNumber(
                              $event,
                              tb.UF_IS_MINUS,
                              indicators.indicators.FINANCE[tb.ID][year.UF_YEAR]
                                .UF_KV1
                            )
                          "
                          @change="
                            numberFix(
                              indicators.indicators.FINANCE[tb.ID][
                                year.UF_YEAR
                              ],
                              'UF_KV1'
                            )
                          "
                          :disabled="editDisabled || year.KV1_IS_EDIT === 0"
                          type="text"
                          class="i-main-style"
                          v-model="
                            indicators.indicators.FINANCE[tb.ID][year.UF_YEAR]
                              .UF_KV1
                          "
                        />
                      </div>
                      <div v-else>
                        <vue-numeric
                          :precision="2"
                          separator="space"
                          output-type="Number"
                          v-if="!tb.UF_IS_BLOCK"
                          v-on:keypress="
                            isNumber(
                              $event,
                              tb.UF_IS_MINUS,
                              indicators.indicators.FINANCE[tb.ID][year.UF_YEAR]
                                .UF_KV1
                            )
                          "
                          @change="
                            numberFix(
                              indicators.indicators.FINANCE[tb.ID][
                                year.UF_YEAR
                              ],
                              'UF_KV1'
                            )
                          "
                          :disabled="editDisabled || year.KV1_IS_EDIT === 0"
                          type="text"
                          class="i-main-style"
                          v-model="
                            indicators.indicators.FINANCE[tb.ID][year.UF_YEAR]
                              .UF_KV1
                          "
                        />
                      </div>
                    </td>
                    <td
                      :class="{
                        gr: year.KV2_IS_VISUALIZATION || tb.UF_IS_BLOCK
                      }"
                    >
                      <span v-if="tb.UF_FORMULA">{{
                        finByFormula(
                          tb.ID,
                          tb.UF_FORMULA,
                          year.UF_YEAR,
                          "UF_KV2"
                        ) | toCurrencyOO
                      }}</span>
                      <vue-numeric
                        :minus="true"
                        :precision="2"
                        separator="space"
                        output-type="Number"
                        v-if="!tb.UF_IS_BLOCK"
                        v-on:keypress="
                          isNumber(
                            $event,
                            tb.UF_IS_MINUS,
                            indicators.indicators.FINANCE[tb.ID][year.UF_YEAR]
                              .UF_KV2
                          )
                        "
                        @change="
                          numberFix(
                            indicators.indicators.FINANCE[tb.ID][year.UF_YEAR],
                            'UF_KV2'
                          )
                        "
                        :disabled="editDisabled || year.KV2_IS_EDIT === 0"
                        type="text"
                        class="i-main-style"
                        v-model="
                          indicators.indicators.FINANCE[tb.ID][year.UF_YEAR]
                            .UF_KV2
                        "
                      />
                    </td>
                    <td
                      :class="{
                        gr: year.KV3_IS_VISUALIZATION || tb.UF_IS_BLOCK
                      }"
                    >
                      <span v-if="tb.UF_FORMULA">{{
                        finByFormula(
                          tb.ID,
                          tb.UF_FORMULA,
                          year.UF_YEAR,
                          "UF_KV3"
                        ) | toCurrencyOO
                      }}</span>
                      <vue-numeric
                        :minus="true"
                        :precision="2"
                        separator="space"
                        output-type="Number"
                        v-if="!tb.UF_IS_BLOCK"
                        v-on:keypress="
                          isNumber(
                            $event,
                            tb.UF_IS_MINUS,
                            indicators.indicators.FINANCE[tb.ID][year.UF_YEAR]
                              .UF_KV3
                          )
                        "
                        @change="
                          numberFix(
                            indicators.indicators.FINANCE[tb.ID][year.UF_YEAR],
                            'UF_KV3'
                          )
                        "
                        :disabled="editDisabled || year.KV3_IS_EDIT === 0"
                        type="text"
                        class="i-main-style"
                        v-model="
                          indicators.indicators.FINANCE[tb.ID][year.UF_YEAR]
                            .UF_KV3
                        "
                      />
                    </td>
                    <td
                      :class="{
                        gr: year.KV4_IS_VISUALIZATION || tb.UF_IS_BLOCK
                      }"
                    >
                      <span v-if="tb.UF_FORMULA">{{
                        finByFormula(
                          tb.ID,
                          tb.UF_FORMULA,
                          year.UF_YEAR,
                          "UF_KV4"
                        ) | toCurrencyOO
                      }}</span>
                      <vue-numeric
                        :minus="true"
                        :precision="2"
                        separator="space"
                        output-type="Number"
                        v-if="!tb.UF_IS_BLOCK"
                        v-on:keypress="
                          isNumber(
                            $event,
                            tb.UF_IS_MINUS,
                            indicators.indicators.FINANCE[tb.ID][year.UF_YEAR]
                              .UF_KV4
                          )
                        "
                        @change="
                          numberFix(
                            indicators.indicators.FINANCE[tb.ID][year.UF_YEAR],
                            'UF_KV4'
                          )
                        "
                        :disabled="editDisabled || year.KV4_IS_EDIT === 0"
                        type="text"
                        class="i-main-style"
                        v-model="
                          indicators.indicators.FINANCE[tb.ID][year.UF_YEAR]
                            .UF_KV4
                        "
                      />
                    </td>
                  </fragment>
                </tr>
              </tbody>
            </fragment>

            <thead>
              <tr style="border-bottom: none !important;">
                <td style="background: none !important;"></td>
              </tr>
              <tr style="border-bottom: none !important;">
                <td style="background: none !important;"></td>
              </tr>
              <tr>
                <th class="tab-wid-630" rowspan="2">Амортизация, тыс. руб.</th>
                <th class="tab-wid-250" colspan="2" style="text-align: center">
                  <br />Код<br /><br />
                </th>
                <th
                  style="text-align: center"
                  colspan="4"
                  v-for="item in indicators.yearAr"
                  v-if="item.IS_ACTIVE"
                >
                  {{ item.UF_YEAR }} год за квартал
                </th>
              </tr>
              <tr>
                <th>
                  <br /><span style="font-weight: normal;">По приказу №66н</span
                  ><br /><br />
                </th>
                <th>
                  <br /><span style="font-weight: normal;">По приказу №67н</span
                  ><br /><br />
                </th>
                <th
                  style="text-align: center"
                  v-for="item in indicatorYearsAmortization"
                  v-html="item"
                ></th>
              </tr>
            </thead>
            <fragment v-for="tb in finSp.AMORTIZATION">
              <tbody>
                <tr>
                  <td>
                    {{ tb.UF_NAME }}
                    <a
                      v-if="tb.UF_HELP"
                      class="icon-help-blue"
                      v-tooltip="{
                        content: tb.UF_HELP,
                        classes: 'message'
                      }"
                    ></a>
                  </td>
                  <td>{{ tb.UF_PRIKAZ_66N }}</td>
                  <td>{{ tb.UF_PRIKAZ_67N }}</td>
                  <fragment
                    v-for="year in indicators.yearAr"
                    v-if="year.IS_ACTIVE"
                  >
                    <td :class="{ gr: year.KV1_IS_VISUALIZATION }">
                      <vue-numeric
                        :minus="true"
                        :precision="2"
                        separator="space"
                        output-type="Number"
                        v-on:keypress="
                          isNumber(
                            $event,
                            tb.UF_IS_MINUS,
                            indicators.indicators.AMORTIZATION[tb.ID][
                              year.UF_YEAR
                            ].UF_KV1
                          )
                        "
                        @change="
                          numberFix(
                            indicators.indicators.AMORTIZATION[tb.ID][
                              year.UF_YEAR
                            ],
                            'UF_KV1'
                          )
                        "
                        :disabled="editDisabled || year.KV1_IS_EDIT === 0"
                        type="text"
                        class="i-main-style"
                        v-model="
                          indicators.indicators.AMORTIZATION[tb.ID][
                            year.UF_YEAR
                          ].UF_KV1
                        "
                      />
                    </td>
                    <td :class="{ gr: year.KV2_IS_VISUALIZATION }">
                      <vue-numeric
                        :minus="true"
                        :precision="2"
                        separator="space"
                        output-type="Number"
                        v-on:keypress="
                          isNumber(
                            $event,
                            tb.UF_IS_MINUS,
                            indicators.indicators.AMORTIZATION[tb.ID][
                              year.UF_YEAR
                            ].UF_KV2
                          )
                        "
                        @change="
                          numberFix(
                            indicators.indicators.AMORTIZATION[tb.ID][
                              year.UF_YEAR
                            ],
                            'UF_KV2'
                          )
                        "
                        :disabled="editDisabled || year.KV2_IS_EDIT === 0"
                        type="text"
                        class="i-main-style"
                        v-model="
                          indicators.indicators.AMORTIZATION[tb.ID][
                            year.UF_YEAR
                          ].UF_KV2
                        "
                      />
                    </td>
                    <td :class="{ gr: year.KV3_IS_VISUALIZATION }">
                      <vue-numeric
                        :minus="true"
                        :precision="2"
                        separator="space"
                        output-type="Number"
                        v-on:keypress="
                          isNumber(
                            $event,
                            tb.UF_IS_MINUS,
                            indicators.indicators.AMORTIZATION[tb.ID][
                              year.UF_YEAR
                            ].UF_KV3
                          )
                        "
                        @change="
                          numberFix(
                            indicators.indicators.AMORTIZATION[tb.ID][
                              year.UF_YEAR
                            ],
                            'UF_KV3'
                          )
                        "
                        :disabled="editDisabled || year.KV3_IS_EDIT === 0"
                        type="text"
                        class="i-main-style"
                        v-model="
                          indicators.indicators.AMORTIZATION[tb.ID][
                            year.UF_YEAR
                          ].UF_KV3
                        "
                      />
                    </td>
                    <td :class="{ gr: year.KV4_IS_VISUALIZATION }">
                      <vue-numeric
                        :minus="true"
                        :precision="2"
                        separator="space"
                        output-type="Number"
                        v-on:keypress="
                          isNumber(
                            $event,
                            tb.UF_IS_MINUS,
                            indicators.indicators.AMORTIZATION[tb.ID][
                              year.UF_YEAR
                            ].UF_KV4
                          )
                        "
                        @change="
                          numberFix(
                            indicators.indicators.AMORTIZATION[tb.ID][
                              year.UF_YEAR
                            ],
                            'UF_KV4'
                          )
                        "
                        :disabled="editDisabled || year.KV4_IS_EDIT === 0"
                        type="text"
                        class="i-main-style"
                        v-model="
                          indicators.indicators.AMORTIZATION[tb.ID][
                            year.UF_YEAR
                          ].UF_KV4
                        "
                      />
                    </td>
                  </fragment>
                </tr>
              </tbody>
            </fragment>
            </template>
          </table>
        </div>
      </div>
      <div class="footer footer-fix">
        <div class="container-fluid mycontainer-fluid">
          <div class="footer-sabmit" v-show="!isLoading">
            <router-link
              tag="button"
              :to="{
                name: 'Projects'
              }"
              class="but-style but-ext"
              value="Отмена"
              >Отмена
            </router-link>
            <button
              class="but-style but-save"
              @click="saveBalance"
              v-if="!editDisabled && mode === 'balance'"
            >
              Сохранить
            </button>
            <button
              class="but-style but-save"
              @click="saveIncome"
              v-if="!editDisabled && mode === 'income'"
            >
              Сохранить
            </button>
          </div>
          <div class="myfooter">
            <div class="myfooter-frp"></div>
          </div>
        </div>
      </div>
    </div>
    <project-menu></project-menu>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { FETCH_PROJECT, FETCH_DIRECTORY } from "../../store/actions.type";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import { ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import ProjectMenu from "@/components/project/partial/ProjectMenu";

Vue.filter("fileName", function(value) {
  let l = value.split("/");

  return l[l.length - 1];
});

Vue.filter("toCurrencyOO", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

export default {
  name: "Indicators",
  title: "Показатели компании",
  watch: {},
  computed: {
    mode() {
      if (this.$route.name === "IndicatorsIncome") return "income";
      return "balance";
    },
    indicatorYears() {
      let r = [];
      for (let i = 0; i < this.indicators.yearAr.length; i++) {
        if (this.indicators.yearAr[i].IS_ACTIVE) {
          r.push("31.03");
          r.push("30.06");
          r.push("30.09");
          r.push(
            "31.12" +
              '<br/><span style="font-weight: normal;">по итогам года</span>'
          );
        }
      }
      return r;
    },
    indicatorYearsFinance() {
      let r = [];
      for (let i = 0; i < this.indicators.yearAr.length; i++) {
        if (this.indicators.yearAr[i].IS_ACTIVE) {
          r.push("I квартал");
          r.push("Полугодие");
          r.push("9 месяцев");
          r.push("Год");
        }
      }
      return r;
    },
    indicatorYearsAmortization() {
      let r = [];
      for (let i = 0; i < this.indicators.yearAr.length; i++) {
        if (this.indicators.yearAr[i].IS_ACTIVE) {
          r.push("I кв");
          r.push("II кв");
          r.push("III кв");
          r.push("IV кв");
        }
      }
      return r;
    },
    ...mapGetters([
      "project",
      "isLoading",
      "isProjectLoading",
      "directory",
      "currentUser",
      "notifications"
    ])
  },
  data() {
    return {
      showTable: true,
      recordsLoaded: false,
      editDisabled: true,
      orgs: [],
      oID: 0,
      activeOrgId: null,
      curOrg: {},
      indicators: {},
      finSp: [],
      siteUrl: "",
      title: ""
    };
  },
  components: {
    ProjectMenu,
    ProjectHeader
  },
  methods: {
    async fetchProject() {
      await this.$store
        .dispatch(FETCH_PROJECT, this.$route.params.id)
        .then(async () => {
          await ProjectsService.getListBalansSp().then(({ data }) => {
            this.finSp["BALANS"] = data.items;
          }, this);
          await ProjectsService.getListFinanceResultSp().then(({ data }) => {
            this.finSp["FINANCE"] = data.items;
          }, this);
          await ProjectsService.getListAmortizationSp().then(({ data }) => {
            this.finSp["AMORTIZATION"] = data.items;
          }, this);
          await ProjectsService.getRulesChangeStatusUser(
            this.project.UF_STATUS_ID
          ).then(({ data }) => {
            if (data.IS_CMP_IND_EDIT) {
              this.editDisabled = false;
            }
          }, this);
          await ProjectsService.getListIndicatorsOrgs(this.project.ID).then(
            ({ data }) => {
              this.orgs = data.items;
              for (let i = 0; i < this.orgs.length; i++) {
                if (this.orgs[i].UF_IS_OWNER_PROJECT) {
                  this.orgs[i].is_active = true;
                  this.loadIndicators(i);
                } else {
                  this.orgs[i].is_active = false;
                }
              }
            },
            this
          );
        });
    },
    getStatus: function(id) {
      let t = this.directory.status.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    },
    indicatorSum(sp, b, year, key) {
      let ret = 0;
      for (let i = 0; i < b.length; i++) {
        if (sp[b[i].ID][year][key]) {
          ret += parseFloat(sp[b[i].ID][year][key]);
        }
      }
      return ret;
    },
    indicatorAPSum(sp, b, year, key) {
      let ret = 0;
      for (let p = 0; p < b.length; p++) {
        if (b[p].UF_CODE === "active") {
          for (let a = 0; a < b[p].CHILDS.length; a++) {
            for (let c = 0; c < b[p].CHILDS[a].CHILDS.length; c++) {
              if (sp[b[p].CHILDS[a].CHILDS[c].ID][year][key]) {
                ret += parseFloat(sp[b[p].CHILDS[a].CHILDS[c].ID][year][key]);
              }
            }
          }
        }
        if (b[p].UF_CODE === "passives") {
          for (let a = 0; a < b[p].CHILDS.length; a++) {
            for (let c = 0; c < b[p].CHILDS[a].CHILDS.length; c++) {
              if (sp[b[p].CHILDS[a].CHILDS[c].ID][year][key]) {
                ret -= parseFloat(sp[b[p].CHILDS[a].CHILDS[c].ID][year][key]);
              }
            }
          }
        }
      }

      if (ret.toFixed(2) == "-0.00" || ret.toFixed(2) == "-0,00") {
        ret = "0.00";
      }

      return ret;
    },
    indicatorChildSum(sp, b, year, key) {
      let ret = 0;
      for (let a = 0; a < b.length; a++) {
        for (let c = 0; c < b[a].CHILDS.length; c++) {
          if (sp[b[a].CHILDS[c].ID][year][key]) {
            ret += parseFloat(sp[b[a].CHILDS[c].ID][year][key]);
          }
        }
      }
      return ret;
    },
    finByFormula(id, f, year, key) {
      for (let a = 0; a < this.finSp["FINANCE"].length; a++) {
        if (this.indicators.indicators.FINANCE[this.finSp["FINANCE"][a].ID]) {
          f = f.replace(
            `[` + this.finSp["FINANCE"][a].ID + `]`,
            this.indicators.indicators.FINANCE[this.finSp["FINANCE"][a].ID][
              year
            ][key]
          );
        }
      }
      f = f.replace("--", "+");
      f = f.replace("--", "+");
      f = f.replace("--", "+");
      f = f.replace("--", "+");
      console.log(f);
      console.log(eval(f));
      Vue.set(this.indicators.indicators.FINANCE[id][year], key, eval(f));
      return eval(f);
    },
    onOrgChange() {
      const idx = this.orgs.findIndex(o => o.ID === this.activeOrgId);
      if (idx !== -1) this.loadIndicators(idx);
    },
    loadIndicators(index) {
      this.recordsLoaded = false;
      for (let i = 0; i < this.orgs.length; i++) {
        if (this.orgs[i].is_active) {
          this.orgs[i].is_active = false;
        }
      }
      this.orgs[index].is_active = true;
      this.oID = this.orgs[index].ID;
      this.activeOrgId = this.orgs[index].ID;
      this.curOrg = this.orgs[index];
      ProjectsService.getIndicatorsByOrg(this.orgs[index].ID).then(
        ({ data }) => {
          this.title =
            "Показатели компании / " +
            this.orgs[index].UF_NAME +
            " (№" +
            this.project.UF_NUMBER +
            ")";
          this.indicators = data;
          let sp = ["BALANS", "FINANCE", "AMORTIZATION"];
          for (let s = 0; s < sp.length; s++) {
            let btype = sp[s];
            if (!this.finSp[btype]) {
              this.finSp[btype] = [];
            }
            for (let a = 0; a < this.finSp[btype].length; a++) {
              if (
                this.finSp[btype][a].CHILDS &&
                this.finSp[btype][a].CHILDS.length > 0
              ) {
                for (let b = 0; b < this.finSp[btype][a].CHILDS.length; b++) {
                  if (this.finSp[btype][a].CHILDS[b].CHILDS) {
                    for (
                      let d = 0;
                      d < this.finSp[btype][a].CHILDS[b].CHILDS.length;
                      d++
                    ) {
                      if (
                        !this.indicators.indicators[sp[s]][
                          this.finSp[sp[s]][a].CHILDS[b].CHILDS[d].ID
                        ]
                      ) {
                        Vue.set(
                          this.indicators.indicators[sp[s]],
                          this.finSp[sp[s]][a].CHILDS[b].CHILDS[d].ID,
                          {}
                        );
                      }
                      for (let c = 0; c < this.indicators.yearAr.length; c++) {
                        if (
                          !this.indicators.indicators[sp[s]][
                            this.finSp[sp[s]][a].CHILDS[b].CHILDS[d].ID
                          ][this.indicators.yearAr[c].UF_YEAR]
                        ) {
                          Vue.set(
                            this.indicators.indicators[sp[s]][
                              this.finSp[sp[s]][a].CHILDS[b].CHILDS[d].ID
                            ],
                            this.indicators.yearAr[c].UF_YEAR,
                            {
                              UF_BALANS_ID: this.finSp[sp[s]][a].CHILDS[b]
                                .CHILDS[d].ID,
                              UF_KV1: null,
                              UF_KV2: null,
                              UF_KV3: null,
                              UF_KV4: null,
                              UF_YEAR: this.indicators.yearAr[c].UF_YEAR
                            }
                          );
                        }
                      }
                    }
                  }
                }
              } else {
                if (
                  !this.indicators.indicators[btype][this.finSp[btype][a].ID]
                ) {
                  Vue.set(
                    this.indicators.indicators[btype],
                    this.finSp[btype][a].ID,
                    {}
                  );
                }
                for (let c = 0; c < this.indicators.yearAr.length; c++) {
                  if (
                    !this.indicators.indicators[btype][this.finSp[btype][a].ID][
                      this.indicators.yearAr[c].UF_YEAR
                    ]
                  ) {
                    Vue.set(
                      this.indicators.indicators[btype][
                        this.finSp[btype][a].ID
                      ],
                      this.indicators.yearAr[c].UF_YEAR,
                      {
                        UF_BALANS_ID: this.finSp[btype][a].ID,
                        UF_KV1: null,
                        UF_KV2: null,
                        UF_KV3: null,
                        UF_KV4: null,
                        UF_YEAR: this.indicators.yearAr[c].UF_YEAR
                      }
                    );
                  }
                }
              }
            }
          }
          this.recordsLoaded = true;
        },
        this
      );
    },
    async saveBalance() {
      await ProjectsService.setBalansByOrg(
        this.oID,
        this.project.UF_STATUS_ID,
        { BALANS: this.indicators.indicators.BALANS }
      ).then(({ data }) => {
        if (data.error) {
          data.errorAr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
        this.$toasted.show("Показатели сохранены", {
          theme: "green",
          position: "bottom-right",
          duration: 3000
        });
      }, this);
    },
    async saveIncome() {
      await ProjectsService.setFinanceByOrg(
        this.oID,
        this.project.UF_STATUS_ID,
        {
          FINANCE: this.indicators.indicators.FINANCE,
          AMORTIZATION: this.indicators.indicators.AMORTIZATION
        }
      ).then(({ data }) => {
        if (data.error) {
          data.errorAr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        }
        this.$toasted.show("Показатели сохранены", {
          theme: "green",
          position: "bottom-right",
          duration: 3000
        });
      }, this);
    },
    async setIsNotFinance() {
      await ProjectsService.setIsNotFinance(
        this.oID,
        this.project.UF_STATUS_ID,
        {
          UF_IS_NOT_FINANCE_OTCH: this.curOrg.UF_IS_NOT_FINANCE_OTCH
        }
      ).then(({ data }) => {
        if (!data.error) {
          console.log("1");
        }
      }, this);
    },
    numberFix: function(o, k) {
      let val = new String(o[k]);
      let l = val.split(".");
      if (l.length > 1) {
        if (l[1].length > 2) {
          o[k] = parseFloat(val);
        }
      }
    },
    isNumber: function(evt, isMinus, val) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      //console.log(isMinus, charCode, evt.target.selectionStart);
      if (
        charCode === 46 &&
        typeof val.indexOf !== "undefined" &&
        val.indexOf(".") !== -1
      ) {
        evt.preventDefault();
        return false;
      }
      if (
        charCode === 45 &&
        typeof val.indexOf !== "undefined" &&
        val.indexOf("-") !== -1
      ) {
        evt.preventDefault();
        return false;
      }
      if (charCode === 46) {
        return true;
      }
      if (isMinus && charCode === 45 && evt.target.selectionStart === 0) {
        return true;
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  async created() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["status"])
      .then(() => {}, this);
    await this.$store.dispatch(FETCH_DIRECTORY, ["ir_sp"]).then(() => {}, this);

    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]).then(() => {
      this.fetchProject();
    }, this);
  }
};
</script>

<style scoped>
/* ===== Tabs ===== */
.gp-f-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.gp-f-tabs__item {
  appearance: none;
  font-family: inherit;
  font-size: 13px;
  color: #2c2c2c;
  background: #ffffff;
  border: 1px solid #cfd2d5;
  border-radius: 3px;
  padding: 7px 14px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;
}

.gp-f-tabs__item:hover {
  border-color: #2b86d0;
  color: #2b86d0;
}

.gp-f-tabs__item--active,
.gp-f-tabs__item--active:hover {
  background: #2676b7;
  border-color: #2676b7;
  color: #ffffff;
  cursor: default;
}

/* ===== Toolbar ===== */
.gp-f-toolbar {
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 14px 10px;
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.gp-f-select {
  position: relative;
  display: inline-block;
  min-width: 320px;
  margin: 0;
}

.gp-f-select__field {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  padding: 7px 32px 7px 12px;
  font-family: inherit;
  font-size: 13px;
  color: #2c2c2c;
  background: #ffffff;
  border: 1px solid #cfd2d5;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.gp-f-select__field:focus {
  border-color: #2b86d0;
  box-shadow: 0 0 0 2px rgba(43, 134, 208, 0.15);
}

.gp-f-select::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 12px;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #2c2c2c;
  transform: translateY(-50%);
  pointer-events: none;
}

.gp-f-years {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
}

.gp-f-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  margin: 0;
  font-weight: normal;
}

.gp-f-toggle__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.gp-f-toggle__slider {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 18px;
  background: #d1d5da;
  border-radius: 999px;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.gp-f-toggle__slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background: #ffffff;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.gp-f-toggle__input:checked + .gp-f-toggle__slider {
  background: #2b86d0;
}

.gp-f-toggle__input:checked + .gp-f-toggle__slider::after {
  transform: translateX(14px);
}

.gp-f-toggle__label {
  font-size: 13px;
  color: #2c2c2c;
}

.gp-f-toolbar__checkbox {
  margin-left: auto;
  font-size: 12px;
  color: #2c2c2c;
}

.gp-f-toolbar__checkbox label {
  font-weight: normal;
  font-size: 13px;
  margin: 0;
}

/* ===== Table ===== */
.content table.c-indicator.gp-f-table {
  border-collapse: collapse;
  font-size: 12px;
  color: #2c2c2c;
}

.content table.c-indicator.gp-f-table thead tr {
  background: transparent;
}

.content table.c-indicator.gp-f-table thead tr th {
  background: #2676b7;
  color: #ffffff;
  font-weight: 400;
  font-size: 12px;
  padding: 12px 8px;
  border: none;
  text-transform: none;
  vertical-align: middle;
}

.content table.c-indicator.gp-f-table thead tr th strong {
  color: #ffffff;
  font-weight: 700;
}

.content table.c-indicator.gp-f-table thead tr th span {
  color: #ffffff;
}

.content table.c-indicator.gp-f-table thead tr td {
  background: none !important;
  padding: 4px 0;
  border: none;
}

.content table.c-indicator.gp-f-table tbody tr td {
  padding: 9px 8px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}

.content table.c-indicator.gp-f-table tbody tr td.gr {
  background: #e9f1f8;
}

.content table.c-indicator.gp-f-table tbody tr:hover {
  background: rgba(233, 241, 248, 0.4);
}

.content table.c-indicator.gp-f-table tbody tr:hover td.gr {
  background: #e9f1f8;
}

.content table.c-indicator.gp-f-table input.i-main-style {
  width: 100%;
  padding: 6px 8px;
  font-size: 12px;
  text-align: right;
  color: #2c2c2c;
  border: 1px solid #cfd2d5;
  border-radius: 3px;
  background: #ffffff;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.content table.c-indicator.gp-f-table input.i-main-style:focus {
  border-color: #2b86d0;
  box-shadow: 0 0 0 2px rgba(43, 134, 208, 0.15);
}

.content table.c-indicator.gp-f-table input.i-main-style:disabled {
  background: #f5f6f7;
  color: #6b6b6b;
}

.content table.c-indicator a.icon-help-blue {
  position: relative;
  width: 16px;
  height: 16px;
  margin-left: 6px;
  vertical-align: middle;
  background-size: contain;
}
</style>
